export const getTagColor = (tag: string) => {
  const colors = {
    // Programming
    JAVA: 'bg-red-100 text-red-800',
    PYTHON: 'bg-red-100 text-red-800',
    JAVASCRIPT: 'bg-red-100 text-red-800',
    TYPESCRIPT: 'bg-red-100 text-red-800',
    REACT: 'bg-red-100 text-red-800',
    ANGULAR: 'bg-red-100 text-red-800',
    VUE: 'bg-red-100 text-red-800',
    NODE_JS: 'bg-red-100 text-red-800',
    SPRING_BOOT: 'bg-red-100 text-red-800',
    DJANGO: 'bg-red-100 text-red-800',
    FLUTTER: 'bg-red-100 text-red-800',
    KOTLIN: 'bg-red-100 text-red-800',
    SWIFT: 'bg-red-100 text-red-800',
    C_SHARP: 'bg-red-100 text-red-800',
    PHP: 'bg-red-100 text-red-800',

    // Data
    SQL: 'bg-blue-100 text-blue-800',
    MONGODB: 'bg-blue-100 text-blue-800',
    POSTGRESQL: 'bg-blue-100 text-blue-800',
    DATA_ANALYSIS: 'bg-blue-100 text-blue-800',
    MACHINE_LEARNING: 'bg-blue-100 text-blue-800',
    AI: 'bg-blue-100 text-blue-800',

    // Design
    UI_DESIGN: 'bg-purple-100 text-purple-800',
    UX_DESIGN: 'bg-purple-100 text-purple-800',
    GRAPHIC_DESIGN: 'bg-purple-100 text-purple-800',
    ADOBE_SUITE: 'bg-purple-100 text-purple-800',
    FIGMA: 'bg-purple-100 text-purple-800',

    // Digital Marketing
    SEO: 'bg-green-100 text-green-800',
    SEM: 'bg-green-100 text-green-800',
    SOCIAL_MEDIA_MARKETING: 'bg-green-100 text-green-800',
    CONTENT_MARKETING: 'bg-green-100 text-green-800',
    EMAIL_MARKETING: 'bg-green-100 text-green-800',

    // Business
    PROJECT_MANAGEMENT: 'bg-amber-100 text-amber-800',
    AGILE: 'bg-amber-100 text-amber-800',
    SCRUM: 'bg-amber-100 text-amber-800',
    BUSINESS_ANALYSIS: 'bg-amber-100 text-amber-800',
    CONSULTING: 'bg-amber-100 text-amber-800',

    // Creative & Art
    PHOTOGRAPHY: 'bg-rose-100 text-rose-800',
    VIDEO_EDITING: 'bg-rose-100 text-rose-800',
    FILM_MAKING: 'bg-rose-100 text-rose-800',
    ANIMATION: 'bg-rose-100 text-rose-800',
    ILLUSTRATION: 'bg-rose-100 text-rose-800',
    CONTENT_WRITING: 'bg-rose-100 text-rose-800',
    PAINTING: 'bg-rose-100 text-rose-800',
    DRAWING: 'bg-rose-100 text-rose-800',
    SCULPTING: 'bg-rose-100 text-rose-800',
    MUSIC: 'bg-rose-100 text-rose-800',
    MUSIC_PRODUCTION: 'bg-rose-100 text-rose-800',

    // Other Professional
    ACCOUNTING: 'bg-slate-100 text-slate-800',
    LEGAL: 'bg-slate-100 text-slate-800',
    SALES: 'bg-slate-100 text-slate-800',
    CUSTOMER_SERVICE: 'bg-slate-100 text-slate-800',
    HR_MANAGEMENT: 'bg-slate-100 text-slate-800',
    RECRUITING: 'bg-slate-100 text-slate-800',

    // Trades
    ELECTRICAL: 'bg-orange-100 text-orange-800',
    PLUMBING: 'bg-orange-100 text-orange-800',
    CARPENTRY: 'bg-orange-100 text-orange-800',
    WELDING: 'bg-orange-100 text-orange-800',
    HVAC: 'bg-orange-100 text-orange-800',
    HOME_RENOVATION: 'bg-orange-100 text-orange-800',
    HANDYMAN: 'bg-orange-100 text-orange-800',

    // Education
    TEACHING: 'bg-cyan-100 text-cyan-800',
    TUTORING: 'bg-cyan-100 text-cyan-800',
    CURRICULUM_DEVELOPMENT: 'bg-cyan-100 text-cyan-800',
    LANGUAGE_TEACHING: 'bg-cyan-100 text-cyan-800',

    // Healthcare
    NURSING: 'bg-teal-100 text-teal-800',
    PHYSIOTHERAPY: 'bg-teal-100 text-teal-800',
    MENTAL_HEALTH: 'bg-teal-100 text-teal-800',
    NUTRITION: 'bg-teal-100 text-teal-800',
    PERSONAL_TRAINING: 'bg-teal-100 text-teal-800',
    PSYCHOLOGY: 'bg-teal-100 text-teal-800',
    DOCTOR: 'bg-teal-100 text-teal-800',

    // Industries by Category
    // Technology
    SOFTWARE_AND_IT: 'bg-indigo-100 text-indigo-800',
    DATA_AND_AI: 'bg-indigo-100 text-indigo-800',
    CYBERSECURITY: 'bg-indigo-100 text-indigo-800',
    GAMING: 'bg-indigo-100 text-indigo-800',

    // Business & Finance
    FINANCIAL_SERVICES: 'bg-emerald-100 text-emerald-800',
    REAL_ESTATE: 'bg-emerald-100 text-emerald-800',
    E_COMMERCE: 'bg-emerald-100 text-emerald-800',

    // Creative & Media
    DIGITAL_MEDIA: 'bg-fuchsia-100 text-fuchsia-800',
    ADVERTISING: 'bg-fuchsia-100 text-fuchsia-800',
    ENTERTAINMENT: 'bg-fuchsia-100 text-fuchsia-800',
    DESIGN: 'bg-fuchsia-100 text-fuchsia-800',

    // Healthcare Industries
    HEALTHCARE: 'bg-sky-100 text-sky-800',
    FITNESS: 'bg-sky-100 text-sky-800',

    // Education Industries
    EDUCATION: 'bg-violet-100 text-violet-800',
    PROFESSIONAL_TRAINING: 'bg-violet-100 text-violet-800',

    // Services
    HOSPITALITY: 'bg-lime-100 text-lime-800',
    RETAIL: 'bg-lime-100 text-lime-800',
    LOGISTICS: 'bg-lime-100 text-lime-800',
    PERSONAL_SERVICES: 'bg-lime-100 text-lime-800',

    // Manufacturing & Construction
    MANUFACTURING: 'bg-yellow-100 text-yellow-800',
    CONSTRUCTION: 'bg-yellow-100 text-yellow-800',

    // Others
    AGRICULTURE: 'bg-stone-100 text-stone-800',
    ENVIRONMENTAL: 'bg-stone-100 text-stone-800',
    NON_PROFIT: 'bg-stone-100 text-stone-800',
    OTHER: 'bg-gray-100 text-gray-800'
  };

  return colors[tag as keyof typeof colors] || 'bg-gray-100 text-gray-800';
}; 